import React from "react";
import * as S from './ManageTripCardStyles';
import Button from "../Button/Button";
import { HOB_BAGGAGE_ICON } from "../../../../../config/constants";

const ManageTripCard = ({
    label= 'Manage Your Trip & Get All The Help',
    btnTxt='Go To My Trips',
    btnClickHandler
}) => {
    return (
      <S.ManageTripCard>
        <S.Label>{label}</S.Label>
        <S.BaggageIcon src={HOB_BAGGAGE_ICON}/>
        <Button btnTxt={btnTxt} type={3} onClick={btnClickHandler} showIcon isCall = {false}/> 
      </S.ManageTripCard>
    );
};

export default ManageTripCard;